module.exports = __webpack_public_path__ + "media/epic-arabian-music-ancient-persian-no-copyright.34ecda3e.mp3";